/* Tejjari product bottom-bar dynamic swap */
(function () {
  var mobileQuery = window.matchMedia('(max-width: 767.98px)');
  var navBar;
  var stickyBar;
  var lastScrollY = window.scrollY;
  var direction = 'up';
  var ticking = false;

  function setMode(mode) {
    document.body.classList.toggle('product-bottom-nav-active', mode === 'nav');
    document.body.classList.toggle('product-bottom-atc-active', mode === 'atc');
  }

  function updateMode() {
    ticking = false;
    if (!mobileQuery.matches || !navBar || !stickyBar) {
      setMode('none');
      return;
    }

    var currentScrollY = window.scrollY;
    var stickyEligible = stickyBar.classList.contains('sticky-atc-bar--show');
    if (currentScrollY < 80 || !stickyEligible || direction === 'up') {
      setMode('nav');
    } else {
      setMode('atc');
    }
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateMode);
  }

  function onScroll() {
    var currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY + 2) direction = 'down';
    if (currentScrollY < lastScrollY - 2) direction = 'up';
    lastScrollY = currentScrollY;
    requestUpdate();
  }

  function init() {
    navBar = document.querySelector('mobile-sticky-bar');
    stickyBar = document.querySelector('.sticky-atc-bar');
    if (!navBar || !stickyBar) return;

    document.body.classList.add('product-bottom-bars-enabled');
    new MutationObserver(requestUpdate).observe(stickyBar, {
      attributes: true,
      attributeFilter: ['class'],
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    mobileQuery.addEventListener('change', requestUpdate);
    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
